import React from "react";
import { TextAreaGroupField } from "components/common/Form/TextAreaGroup";
import { CourseQuizQuestion } from "../types";
import styles from "./EssayQuestion.module.css";

interface EssayQuestionProps {
  question: CourseQuizQuestion;
}

const EssayQuestion = ({ question }: EssayQuestionProps) => {
  if (!question.id) {
    throw new Error(`Invalid question: ${JSON.stringify(question)}`);
  }

  return <TextAreaGroupField label="" name={question.id} textareaClassName={styles.textarea} />;
};

export default EssayQuestion;
